import { ScheduleState } from "../../../type/schedule-state";

export const clearUpdateScheduleDispatch = (state: ScheduleState) => {
  state.updateSchedule = undefined;
};
